import {useContext, useState, useEffect} from 'react';

import { useNavigate , useLocation } from "react-router-dom";
import {Nav, Image, Button, Navbar, Offcanvas, Container, Dropdown, Form} from 'react-bootstrap';
import { List, BoxArrowInRight, Cart2, Person} from 'react-bootstrap-icons';
import './barline.css';
import CatalogMenu from '../components/Catalog/CatalogMenu'
import SearchInput from './Search/SearchInput';
import { Context } from "../index"; // импорт контекста
import nmb from '../assets/nmb_7.svg'
import { getNewCatalog } from "../http/productAPI";


import {
    ABOUT_ROUTE, BASKET_ROUTE, BRANDS_ROUTE, CONTACTS_ROUTE,
    PAY_AND_SHIP_ROUTE, REFUND_ROUTE, SERVICES_ROUTE,
    WARRANTY_ROUTE, LOGIN_ROUTE, PROFILE_ROUTE, HISTORY_ROUTE, PROMOTIONS_PAGE
} from "../utils/const";
import {observer} from "mobx-react-lite";

const BarLine = observer(() => {
    const { user, product } = useContext(Context);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const location = useLocation();
    const navigate = useNavigate(); // Хук для навигации
    const isLoginPage = location.pathname === "/login"; // Проверяем, находимся ли на странице логина
    const handleGoToHome = () => {      // кнопка редиректа на главную страницу со страницы входа
        navigate("/"); 
    };
  
    const handleLogout = () => {          // Логика выхода (удаляем токен, очищаем user и статус авторизации)
        localStorage.removeItem("token");
        localStorage.removeItem("user");
    //    user.setUser({}); // Обнуляем пользователя, но оставляем объект 
        user.setIsAuth(false);
        user.setToken(null);
        user.setviewAsManager(false);
        window.location.reload()
    };

    const handleLoginClick = () => {
        // Сохраняем текущий путь в sessionStorage
        sessionStorage.setItem("returnTo", location.pathname);
    
        // Переход на логин
        navigate(LOGIN_ROUTE);
    };
    
    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        const storedToken = localStorage.getItem('token');
        if (storedUser && storedToken) {
            user.setUser(JSON.parse(storedUser));
            user.setIsAuth(true);
        }
    }, [user]);    

    useEffect(() => {
              // ОБЯЗАТЕЛЬНО ВНУТРИ useEffect
              getNewCatalog().then(data => product.setCategories(data));
          }, []); // Выполнится один раз при монтировании  

    return (
        <Navbar sticky="top" className={`py-3 d-sm-block navbar-sticky ${isLoginPage ? 'barline-login' : ''}`}>
            <Container className="d-flex justify-content-between align-items-center">
                    {isLoginPage && (
                        <Button  variant="outline-dark" className="me-auto me-lg-2 rounded-4 align-items-center" onClick={handleGoToHome}>
                            Главная
                        </Button>
                    )}
                <Button variant="outline-dark" className="me-auto me-lg-2 rounded-4 align-items-center" onClick={handleShow}>
                    <span className="d-block d-lg-none"><List className="me-2"/>Меню</span>
                    <span className="d-none d-lg-block"><List className="me-2"/>Каталог</span>
                </Button>

                {/*ЛЕвый выпадающий слайдер с поиском и каталогом*/}
                <Offcanvas show={show} onHide={handleClose}  bg="dark" data-bs-theme="dark">
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title>Каталог</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Navbar className="d-block d-xl-none">
                            <Nav className="d-flex modalnav" as="ul">
                                <Nav.Link href={PROMOTIONS_PAGE} className="text-danger">Акции</Nav.Link>
                                <Nav.Link href={BRANDS_ROUTE}>Бренды</Nav.Link>
                                <Nav.Link href={SERVICES_ROUTE}>Услуги</Nav.Link>
                            </Nav>
                        </Navbar>

                        {/*можно убрать дивы если поковаться со стилями*/}
                        <div className="d-block d-lg-none flex-fill me-3">    
                            <SearchInput placeholder="Найти, например сплит-система..." className="sideform" onSearch={handleClose}/>
                        </div>
                        
                        <CatalogMenu categories={product.categories}/>

                        <Navbar className="d-block d-lg-none">
                            <Nav className="flex-column modalnav" as="ul">
                                <Nav.Link href={ABOUT_ROUTE}>О компании</Nav.Link>
                                <Nav.Link href={PAY_AND_SHIP_ROUTE}>Оплата и доставка</Nav.Link>
                                <Nav.Link href={WARRANTY_ROUTE}>Гарантия</Nav.Link>
                                <Nav.Link href={REFUND_ROUTE}>Возврат</Nav.Link>
                                <Nav.Link href={CONTACTS_ROUTE}>Контакты</Nav.Link>
                            </Nav>
                        </Navbar>
                        <Image src={nmb} className="nmb_evo7_barline" alt="nmb_evo7_barline"/>
                    </Offcanvas.Body>
                </Offcanvas>

                {/* Верхняя плашка страницы*/}
                <Navbar className="d-none d-xl-block">
                    <Nav className="me-auto" as="ul">
                        <Nav.Link href={PROMOTIONS_PAGE} className="text-danger">Акции</Nav.Link>
                        <Nav.Link href={BRANDS_ROUTE}>Бренды</Nav.Link>
                        <Nav.Link href={SERVICES_ROUTE}>Услуги</Nav.Link>
                    </Nav>
                </Navbar>

                <div className="d-none d-lg-flex flex-fill mx-3">
                        <SearchInput placeholder="Найти, например сплит-система Daichi..." />
                </div>

                <a href={BASKET_ROUTE} className="d-flex mx-4 align-items-center barcart">
                    <Cart2 className="me-2"/>
                    <span className="d-none d-lg-inline"> Корзина  </span>
                    <span className="cart-counter bg-danger text-light">
                        {product.basketProducts?.map(basketProduct => basketProduct.count).reduce((a, c) => a + c, 0)}
                    </span>
                </a>
                    {/* Если пользователь авторизован */}
                    {user.isAuth && user.user ? (
                        <Dropdown  className="ms-3 rounded-4">
                        <Dropdown.Toggle variant="outline-dark" id="dropdown-basic" className="d-flex align-items-center ms-3 rounded-4 border border-0" >
                            <Person className="me-2" />
                            <span>{user.user.lastName} {user.user.name ? user.user.name.charAt(0) + "." : ""}</span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu align="end" className="ms-3 rounded-4">
                                    {/* ✅ Переключатель только если роль shop */}
                            {user.hasRoleShop === true && (                            
                              <Dropdown.ItemText className="d-flex justify-content-between align-items-center">
                                {user.viewAsManager ? "Сотрудник" : "Клиент"}
                                <Form.Check
                                  type="switch"
                                  id="role-switch"
                                  checked={user.viewAsManager}
                                  onChange={(e) => user.setviewAsManager(e.target.checked)}
                                  className="ms-2"
                                />
                              </Dropdown.ItemText>                           
                            )}
                            <Dropdown.Divider />
                                <Dropdown.Item onClick={() => navigate(PROFILE_ROUTE)}>Профиль</Dropdown.Item>
                                <Dropdown.Item onClick={() => navigate(HISTORY_ROUTE)}>История заказов</Dropdown.Item>  
                            {/*<Dropdown.Item onClick={() => navigate("/payments")}>Взаиморасчёты</Dropdown.Item>*/}
                            <Dropdown.Divider />
                            <Dropdown.Item onClick={handleLogout} className="text-danger">Выйти</Dropdown.Item>
                        </Dropdown.Menu>
                        </Dropdown>                     
                    ) : (
                        <Button
                            variant="outline-dark"
                            className="rounded-4"
                            onClick={handleLoginClick}
                        >
                            <BoxArrowInRight className="me-2" />
                            Войти
                        </Button>
                    )} 
            </Container>
        </Navbar>
    );
});

export default BarLine;